import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { ConfigField } from "../config-pane-parts";

export interface IConfigDateFormatProps {
  parentData?: string;
  parentConfigValue?: string | null;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
}

/**
 * A fixed list rather than saved settings, which is why it is two plain selects and not
 * `ConfigSettingSelect` — there is nothing here to add or edit.
 */
export class ConfigDateFormat extends PureComponent<IConfigDateFormatProps> {
  dateFormats: KuikaSelectboxOption[] = [
    { value: "dd/mm/yyyy", label: "DD/MM/YYYY" },
    { value: "mm/dd/yyyy", label: "MM/DD/YYYY" },
    { value: "yyyy/mm/dd", label: "YYYY/MM/DD" },
    { value: "dd-mm-yyyy", label: "DD-MM-YYYY" },
    { value: "mm-dd-yyyy", label: "MM-DD-YYYY" },
    { value: "yyyy-mm-dd", label: "YYYY-MM-DD" },
    { value: "dd.mm.yyyy", label: "DD.MM.YYYY" },
    { value: "mm.dd.yyyy", label: "MM.DD.YYYY" },
    { value: "yyyy.mm.dd", label: "YYYY.MM.DD" }
  ];

  timeFormats: KuikaSelectboxOption[] = [
    { value: "hh:mm", label: "HH:MM" },
    { value: "hh:mm:ss", label: "HH:MM:SS" },
    { value: "hh:mm a", label: "HH:MM AM/PM" },
    { value: "hh:mm:ss a", label: "HH:MM:SS AM/PM" }
  ];

  render(): ReactNode {
    const parentData: string = this.props.parentData ?? "webConfig";
    const dateFormatFormInputName: string[] = [parentData, "dateFormat"];
    const timeFormatFormInputName: string[] = [parentData, "timeFormat"];
    const isOverridden: boolean = this.props.parentConfigValue !== undefined;

    return (
      <>
        <ConfigField
          label="Date Format"
          tooltipContentKey="appsettings_date_timeformats_dateformat"
          onRestore={
            isOverridden
              ? () =>
                  this.props.handleUpdateCustomFormInput?.(
                    dateFormatFormInputName,
                    this.props.parentConfigValue ?? null
                  )
              : undefined
          }
        >
          <Form.Item name={dateFormatFormInputName}>
            <KuikaSelectbox
              size="md"
              data-testid="appSettingsDateFormatDropdown"
              options={this.dateFormats}
              placeholder="Select Date Format"
              allowClear
            />
          </Form.Item>
        </ConfigField>

        <ConfigField
          label="Time Format"
          tooltipContentKey="appsettings_date_timeformats_timeformat"
          onRestore={
            isOverridden
              ? () =>
                  this.props.handleUpdateCustomFormInput?.(
                    timeFormatFormInputName,
                    this.props.parentConfigValue ?? null
                  )
              : undefined
          }
        >
          <Form.Item name={timeFormatFormInputName}>
            <KuikaSelectbox
              size="md"
              data-testid="appSettingsTimeFormatDropdown"
              options={this.timeFormats}
              placeholder="Select Time Format"
              allowClear
            />
          </Form.Item>
        </ConfigField>
      </>
    );
  }
}
